export const urls = {
  catalogEmpty: '/',
  catalogList: '/list',
  newCategory: '/new-category',
  newProduct: '/new-product',
  existingProducts: '/product-list',
  editCategory: '/edit-category/:categoryId',
  editProduct: '/edit-product/:productId'
};
